"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Overlay(_a) {
    var brand = _a.brand, onChange = _a.onChange;
    return react_1.default.createElement("div", { className: 'storybook-channels-branding-overlay' },
        react_1.default.createElement("input", { className: 'storybook-forms-thumbnail-upload', type: 'file', onChange: function (event) {
                var file = event.target.files[0];
                file.preview = URL.createObjectURL(file);
                onChange(file);
            } }),
        react_1.default.createElement("div", { className: 'flex flex-col items-center' },
            react_1.default.createElement("span", { className: 'storybook-forms-thumbnail-icon' },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'camera', className: 'storybook-icons-icon' })),
            react_1.default.createElement(storybook_1.Texts.Primary, { className: 'storybook-forms-thumbnail-text' },
                brand.label,
                " vervangen")));
}
function BrandingPreview(_a) {
    var type = _a.type, preview = _a.preview;
    return (react_1.default.createElement("div", { className: "storybook-channels-branding-image-" + type, style: { backgroundImage: "url(" + preview + ")" } }));
}
function BrandingImage(_a) {
    var brand = _a.brand, image = _a.image, onChange = _a.onChange;
    var preview = typeof image === 'object' ? image.preview : image;
    return react_1.default.createElement("div", { className: 'storybook-channels-branding-image' },
        react_1.default.createElement("div", { className: 'storybook-channels-branding-image-body' },
            react_1.default.createElement(BrandingPreview, { type: brand.type, preview: preview }),
            brand.type === 'logo' && react_1.default.createElement(BrandingPreview, { type: brand.type, preview: preview }),
            brand.type === 'watermark' && react_1.default.createElement("img", { className: 'absolute bottom-8', src: process.env.NEXT_PUBLIC_STORYBOOK_CDN_URL + '/dashboard/img/player-controls.svg', alt: '' })),
        react_1.default.createElement(Overlay, { brand: brand, onChange: onChange }));
}
exports.default = BrandingImage;
